import React, { useEffect, useState } from "react";
import Navbar from "../../navbar/navbar";
import Sidebar from "../../navbar/sidebar";
import { Card, Pagination, Table, Button, Col, InputGroup,Form,Dropdown }
  from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { getAllActas } from "../../services/apiService";
import { BsChevronExpand, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FcSearch } from "react-icons/fc";
import api from "../../services/api";

const API_URL = "https://sivempc.veracruz.gob.mx/api/";
//const API_URL = "http://10.2.17.55:8000/api/";

export default function ActasEnt() {
  document.title = "Actas Circunstanciadas";

  const token = localStorage.getItem("user");
  const userId = token ? jwtDecode(token).id : null;
  const userRole = token ? jwtDecode(token).TipoUsuario : null;
  const tipoUser1 = "Administrador";
  const tipoUser2 = "Senior";


  // eslint-disable-next-line
  const [tempost, setTempost] = useState([]);
  const [dias, setDias] = useState("");

  useEffect(() => {
    // Este efecto se ejecutará cada vez que dias cambie
  }, [dias]);

  // Paginación
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [folio, setFolio] = useState("");
  const [folioInput, setFolioInput] = useState("");
  const [estadoId, setEstadoId] = useState("");
  const [estadoInput, setEstadoIdInput] = useState("");

  //Novo
  const [actas, setActas] = useState([]);

  const handleAplicarFiltros = () => {
    setFolio(folioInput || null);
    setEstadoId(estadoInput || null);
    setCurrentPage(0); // volver a la primera página
  };

  const handleLimpiarFiltros = () => {
    setFolioInput('');
    setFolio('');
    setEstadoId('');
    setEstadoIdInput('');
    setCurrentPage(0);
  };

  const getData = async (event) => {
    try {
      let response;
      response = await getAllActas(
        currentPage,
        pageSize,
        folio,
        estadoId,
      )
      setActas(response.acta || []);
      setTotalPages(response.totalPages || 0);
      setTotalElements(response.totalItems || 0);


    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line 
  }, [
    currentPage,
    pageSize,
    folio,
    estadoId,
  ]);

  // Inicio Paginación

  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };
  const handleNext = () => {
    if (totalPages === 0) return;

    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };
  const getPaginationItems = () => {
    let items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    // Ajustar si estamos cerca del final
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Primera página
    if (startPage > 0) {
      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 0}
          onClick={() => handlePageChange(1)}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }

    // Páginas intermedias
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i + 1}
          active={i === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      );
    }

    // Última página
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages - 1}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };
  // Fin Paginación

  const updateActaApercibida = async (id) => {
    api
      .put(API_URL + `actualizarEstadoActa/${id}`, {
        estadosacta: { id: 2 },
        editado: Date.now(),
        editado_por: userId,
        dias_habiles: dias,
        tiempo: Date.now()

      })
      .then((response) => {
        setTempost(response.data);
      });
    window.location.reload();
  };
  const updateActaAmonestacion = async (id) => {
    api
      .put(API_URL + `actualizarEstadoActa/${id}`, {
        estadosacta: { id: 3 },
        editado: Date.now(),
        editado_por: userId,
        dias_habiles: dias,
        tiempo: Date.now()
      })
      .then((response) => {
        setTempost(response.data);
      });
    window.location.reload();
  };
  const updateActaPAS = async (id) => {
    api
      .put(API_URL + `actualizarEstadoActa/${id}`, {
        estadosacta: { id: 4 },
        editado: Date.now(),
        editado_por: userId,
        dias_habiles: 0,
        tiempo: Date.now()
      })
      .then((response) => {
        setTempost(response.data);
      });
    window.location.reload();
  };
  const updateActaDTR = async (id) => {
    api
      .put(API_URL + `actualizarEstadoActa/${id}`, {
        estadosacta: { id: 5 },
        editado: Date.now(),
        editado_por: userId,
        dias_habiles: 0,
        tiempo: Date.now()
      })
      .then((response) => {
        setTempost(response.data);
      });
    window.location.reload();
  };
  const updateActaSuspencion = async (id) => {
    api
      .put(API_URL + `actualizarEstadoActa/${id}`, {
        estadosacta: { id: 6 },
        editado: Date.now(),
        editado_por: userId,
        dias_habiles: 0,
        tiempo: Date.now()
      })
      .then((response) => {
        setTempost(response.data);
      });
    window.location.reload();
  };
  const [dropdownTexts, setDropdownTexts] = useState({});

  function dias7(id) {
    const d7 = 7;
    setDias(d7);
    setDropdownTexts(prev => ({ ...prev, [id]: "7 días" }));
  }
  function dias14(id) {
    const d14 = 14;
    setDias(d14);
    setDropdownTexts(prev => ({ ...prev, [id]: "14 días" }));
  }
  function dias21(id) {
    const d21 = 21;
    setDias(d21);
    setDropdownTexts(prev => ({ ...prev, [id]: "21 días" }));
  }
  function dias42(id) {
    const d42 = 42;
    setDias(d42);
    setDropdownTexts(prev => ({ ...prev, [id]: "42 días" }));
  }
  function dias63(id) {
    const d63 = 63;
    setDias(d63);
    setDropdownTexts(prev => ({ ...prev, [id]: "63 días" }));
  }

  return (
    <div className="flex">
      <Sidebar />
      <div className="content w-100 cont">
        <Navbar />
        
          <h2 className="text-center">
            <strong>SEGUIMIENTO </strong>
          </h2>

          <Card className="card-tabla">
            <Table
              hover
              size="sm"
              responsive
              className="tablecursos text-center"
            >
              <thead className="table-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Oficio</th>
                  <th scope="col">Empresa</th>
                  <th scope="col">Estado actual</th>
                  <th scope="col">Núm. Días</th>
                  <th scope="col">Cambiar estado</th>
                </tr>
              </thead>
              <tbody>
                {actas.length > 0 ? (
                  actas.map((acta, i) => (
                    <tr key={acta.id} >
                      <td>{i + 1}</td>
                      <td>{acta.folio}</td>
                      <td>{acta.nombre_empresa}</td>
                      <td>{acta.estadosacta.estado}</td>

                      <td>
                        {userRole === tipoUser1 || tipoUser2 ? (
                          acta.estadosacta.id === 3 ? (
                            <>
                              <strong className="text-dark">
                                {acta.dias_habiles}
                              </strong>
                            </>
                          ) : acta.estadosacta.id === 4 ? (
                            <>
                              <strong className="text-dark">0</strong>
                            </>
                          ) : acta.estadosacta.id === 5 ? (
                            <>
                              <strong className="text-dark">0</strong>
                            </>
                          ) : acta.estadosacta.id === 6 ? (
                            <>
                              <strong className="text-dark">0</strong>
                            </>
                          ) : (
                            <Dropdown>
                              <Dropdown.Toggle variant="secondary" size="sm" id={`dropdown-dias-${acta.id}`}>
                                {dropdownTexts[acta.id] || "Días habiles"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => dias7(acta.id)}>
                                  7
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => dias14(acta.id)}>
                                  14
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => dias21(acta.id)}>
                                  21
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => dias42(acta.id)}>
                                  42
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => dias63(acta.id)}>
                                  63
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          )
                        ) : (
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="secondary"
                              size="sm"
                              id="dropdown-basic"
                            >
                              Días habiles
                            </Dropdown.Toggle>
                          </Dropdown>
                        )}
                      </td>
                      <td>
                        {userRole === tipoUser1 || tipoUser2 ? (
                          acta.estadosacta.id === 5 ? (
                            <>
                              <strong className="text-success">
                                Concluido
                              </strong>
                            </>
                          ) : acta.estadosacta.id === 6 ? (
                            <>
                              <strong className="text-dark">Suspendido</strong>
                            </>
                          ) : (
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                size="sm"
                                id="dropdown-basic"
                              >
                                Actualizar estado
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                {acta.estadosacta.id === 1 ? (
                                  <>
                                    <Dropdown.Item
                                      onClick={() =>
                                        updateActaApercibida(acta.id)
                                      }
                                    >
                                      Apercibimiento
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        updateActaSuspencion(acta.id)
                                      }
                                    >
                                      Suspensión
                                    </Dropdown.Item>
                                  </>
                                ) : acta.estadosacta.id === 2 ? (
                                  <>
                                    <Dropdown.Item
                                      onClick={() =>
                                        updateActaAmonestacion(acta.id)
                                      }
                                    >
                                      Amonestación
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        updateActaSuspencion(acta.id)
                                      }
                                    >
                                      Suspensión
                                    </Dropdown.Item>
                                  </>
                                ) : acta.estadosacta.id === 3 ? (
                                  <>
                                    <Dropdown.Item
                                      onClick={() => updateActaPAS(acta.id)}
                                    >
                                      PAS
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        updateActaSuspencion(acta.id)
                                      }
                                    >
                                      Suspensión
                                    </Dropdown.Item>
                                  </>
                                ) : acta.estadosacta.id === 4 ? (
                                  <>
                                    <Dropdown.Item
                                      onClick={() => updateActaDTR(acta.id)}
                                    >
                                      DTR
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        updateActaSuspencion(acta.id)
                                      }
                                    >
                                      Suspensión
                                    </Dropdown.Item>
                                  </>
                                ) : /*: acta.estadosacta.id === 6 ? (
                                    <>
                                      <Dropdown.Item onClick={() => updateActaDTR(acta.id)}>DTR</Dropdown.Item>
                                    </>)*/
                                  null}
                              </Dropdown.Menu>
                            </Dropdown>
                          )
                        ) : (
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="secondary"
                              size="sm"
                              id="dropdown-basic"
                            >
                              Actualizar estado
                            </Dropdown.Toggle>
                          </Dropdown>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No hay registros para mostrar
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card>


          <Card className="card-fix">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="d-flex align-items-center gap-2">
                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Folio</b>
                    </label>
                    <InputGroup className="">
                      <InputGroup.Text>
                        <FcSearch />
                      </InputGroup.Text>
                      <Form.Control
                        placeholder="Buscar por Folio..."
                        value={folioInput}
                        onChange={(e) => setFolioInput(e.target.value)}
                      />
                    </InputGroup>
                  </div>
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Estado</b>
                    </label>
                    <InputGroup className="">
                      <InputGroup.Text id="basic-addon1">
                        <BsChevronExpand /> {" "}
                      </InputGroup.Text>
                      <Form.Select
                        className="form-control"
                        name="estadoInput"
                        value={estadoInput}
                        onChange={(e) => setEstadoIdInput(e.target.value)}
                      >
                        <option value="">-- Seleccione estado --</option>
                        <option value="1">Levantamiento</option>
                        <option value="2">Apercibimiento</option>
                        <option value="3">Amonestación</option>
                        <option value="4">Procedimiento Administrativo Sancionador</option>
                        <option value="5">Dictamen técnico de riesgos</option>
                        <option value="6">Suspensión de actividades</option>

                      </Form.Select>

                    </InputGroup>
                  </div>
                </Col>

                <Col xs={6} md={3} className="d-flex gap-2">
                  <Button
                    variant="success"
                    className="w-100"
                    onClick={handleAplicarFiltros}
                  >
                    Aplicar
                  </Button>

                  <Button
                    variant="dark"
                    className="w-100"
                    onClick={handleLimpiarFiltros}
                  >
                    Limpiar
                  </Button>
                </Col>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center ">
              <div className="d-flex align-items-center gap-2">
                <span>Registros por página:</span>
                <select
                  className="form-select form-select-sm"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: "80px" }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>

              </div>
              <div className="text-muted">
                Mostrando{" "}
                <strong>
                  {currentPage * pageSize + 1}-
                  {Math.min((currentPage + 1) * pageSize, totalElements)}
                </strong>{" "}
                de <strong>{totalElements}</strong> registros
              </div>

              <div className="d-flex align-items-center gap-2">
                <Button
                  variant="outline-dark"
                  onClick={handlePrevious}
                  disabled={currentPage === 0}
                  className="d-flex align-items-center gap-1"
                >
                  <BsChevronLeft />
                  <span>Anterior</span>
                </Button>

                <Pagination className="mb-0">
                  {getPaginationItems()}
                </Pagination>

                <Button
                  variant="outline-dark"
                  onClick={handleNext}
                  disabled={currentPage >= totalPages - 1}
                  className="d-flex align-items-center gap-1"
                >
                  <span>Siguiente</span>
                  <BsChevronRight />
                </Button>
              </div>
            </div>
          </Card>
       
      </div>
    </div>
  );
}
